// [rail epic] Pure math for the chat/document split on Home, kept apart from the
// component so the 40/60 default, the clamping and the drag can be tested.
export const RAIL_DEFAULT_FRACTION = 0.6;
export const RAIL_MIN_WIDTH = 360;
export const CHAT_MIN_WIDTH = 360;

/** Pixel width of the document rail for a given fraction of the usable space
 *  (container minus the gap), never letting either side drop under its minimum. */
export function railPixelWidth(
  fraction: number,
  containerWidth: number,
  gap: number
): number | undefined {
  const usable = Math.max(containerWidth - gap, 0);
  if (usable === 0) return undefined;
  const maxRail = Math.max(usable - CHAT_MIN_WIDTH, RAIL_MIN_WIDTH);
  return Math.round(Math.min(Math.max(fraction * usable, RAIL_MIN_WIDTH), maxRail));
}

/** The fraction a drag to `clientX` means: the rail spans from the pointer (minus
 *  half the handle) to the container's right edge. */
export function fractionFromPointer(
  clientX: number,
  containerRight: number,
  containerWidth: number,
  gap: number,
  handleHalf: number
): number {
  const px = containerRight - clientX - handleHalf;
  return px / Math.max(containerWidth - gap, 1);
}
